import { render } from "./MultiSignOff.vue?vue&type=template&id=5d2e1964&scoped=true"
import script from "./MultiSignOff.vue?vue&type=script&lang=js"
export * from "./MultiSignOff.vue?vue&type=script&lang=js"

import "./MultiSignOff.vue?vue&type=style&index=0&id=5d2e1964&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d2e1964"]])

export default __exports__